/* KOJO · campaign landing runtime: one clock for every countdown, silhouette roulettes, advent calendar (reveal at 0 via
   the Section Rendering API — the server decides the hour), next-piece tile, signup forms (AJAX + native fallback, Lead
   event), «Avísame» buttons, sticky bar, ribbon pause, Reyes seal stamp, bento «ver todas».
   Vanilla, no dependencies (uses window.KJ.toast when kojo-core.js is present). Safe to load twice. */
(function () {
  'use strict';
  if (window.KJLanding) return;
  var doc = document;
  doc.documentElement.classList.add('kj-lp-js');
  var L = window.KJLanding = { paused: false, tries: {} };
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var design = function () { return !!(window.Shopify && window.Shopify.designMode); };
  var reduced = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };
  function define(name, ctor) { if (!customElements.get(name)) { try { customElements.define(name, ctor); } catch (e) {} } }
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); if (v === null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v); } catch (e) {} return null; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function slug(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40); }
  function toast(msg) { if (window.KJ && window.KJ.toast) window.KJ.toast(msg); }

  /* ---------- one clock ---------- */
  var subs = [], timer = 0;
  function tick() { var now = Date.now() / 1000; subs.slice().forEach(function (fn) { try { fn(now); } catch (e) {} }); }
  function sub(fn) {
    subs.push(fn);
    if (!timer) timer = setInterval(tick, 1000);
    fn(Date.now() / 1000);
    return function () { var i = subs.indexOf(fn); if (i > -1) subs.splice(i, 1); if (!subs.length && timer) { clearInterval(timer); timer = 0; } };
  }
  function parts(diff) { diff = Math.max(0, Math.floor(diff)); return { d: Math.floor(diff / 86400), h: Math.floor(diff % 86400 / 3600), m: Math.floor(diff % 3600 / 60), s: diff % 60 }; }
  function short(diff, secsH) {
    var p = parts(diff);
    var out = (p.d > 0 ? (p.d > 99 ? p.d : pad(p.d)) + 'D ' : '') + pad(p.h) + 'H ' + pad(p.m) + 'M';
    if (secsH > 0 && diff < secsH * 3600) out += ' ' + pad(p.s) + 'S';
    return out;
  }
  L.sub = sub;
  L.short = short;

  /* ---------- <kj-countdown> ---------- */
  define('kj-countdown', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.to = parseFloat(this.getAttribute('data-to')) || 0;
      this.fmt = this.getAttribute('data-format') || 'short';
      this.secs = this.hasAttribute('data-secs') ? parseFloat(this.getAttribute('data-secs')) : 24;
      this.u = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { self.u[k] = self.querySelector('[data-u="' + k + '"]'); });
      this.done = false;
      this._m = -1;
      if (this.unsub) this.unsub();
      this.unsub = sub(function (now) { self.render(now); });
    }
    disconnectedCallback() { if (this.unsub) { this.unsub(); this.unsub = null; } }
    set(to) { this.to = to; this.done = false; this.classList.remove('is-done'); this.render(Date.now() / 1000); }
    render(now) {
      if (!this.to) return;
      var diff = this.to - now;
      var p = parts(diff);
      if (this.fmt === 'boxes') {
        if (this.u.d) this.u.d.textContent = p.d > 99 ? p.d : pad(p.d);
        if (this.u.h) this.u.h.textContent = pad(p.h);
        if (this.u.m) this.u.m.textContent = pad(p.m);
        if (this.u.s) this.u.s.textContent = pad(p.s);
      } else {
        var t = short(diff, this.secs);
        if (this.textContent !== t) this.textContent = t;
      }
      if (p.m !== this._m) {
        this._m = p.m;
        this.setAttribute('aria-label', diff > 0 ? 'Faltan ' + (p.d ? p.d + ' días, ' : '') + p.h + ' horas y ' + p.m + ' minutos' : 'Ya ha llegado la hora');
      }
      if (diff <= 0 && !this.done) {
        this.done = true;
        this.classList.add('is-done');
        this.dispatchEvent(new CustomEvent('kj:countdown:end', { bubbles: true }));
      }
    }
  });

  /* ---------- roulettes ---------- */
  function poolFor(el) {
    var sec = el.closest('.shopify-section') || doc;
    var src = sec.querySelector('[data-kj-sil-pool]') || doc.querySelector('[data-kj-sil-pool]');
    if (!src) return [];
    if (!src._pool) { try { src._pool = JSON.parse(src.textContent) || []; } catch (e) { src._pool = []; } }
    return src._pool;
  }
  var roulIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { var r = en.target._kjRoul; if (r) { r.visible = en.isIntersecting; r.sched(); } });
  }, { rootMargin: '60px' }) : null;
  var roulettes = [];
  function Roulette(el) {
    if (el._kjRoul) return el._kjRoul;
    el._kjRoul = this;
    this.el = el;
    this.imgs = el.querySelectorAll('.kj-roul__img');
    this.seed = parseInt(el.getAttribute('data-seed'), 10) || 0;
    this.i = this.seed;
    var host = el.closest('[data-kj-roul-ms]');
    this.base = host ? (parseInt(host.getAttribute('data-kj-roul-ms'), 10) || 1700) : 1700;
    this.interval = this.base;
    this.visible = !roulIO;
    // safety net: a roulette rendered without images (empty fallback) is rebuilt from the campaign pool
    if (!el.hasAttribute('data-fixed') && this.imgs.length < 2) {
      var pool = poolFor(el);
      var stage = el.querySelector('.kj-roul__stage');
      if (stage && pool.length >= 2) {
        stage.innerHTML = '';
        for (var k = 0; k < 2; k++) {
          var im = doc.createElement('img');
          im.className = 'kj-roul__img' + (k ? '' : ' is-on');
          im.alt = '';
          im.width = 360;
          im.height = 360;
          im.decoding = 'async';
          im.draggable = false;
          if (!k) im.src = pool[this.seed % pool.length];
          stage.appendChild(im);
        }
        this.imgs = el.querySelectorAll('.kj-roul__img');
      }
    }
    if (el.hasAttribute('data-fixed') || this.imgs.length < 2) return;
    roulettes.push(this);
    if (roulIO) roulIO.observe(el);
    this.sched();
  }
  Roulette.prototype.active = function () { return this.el.isConnected && this.visible && !L.paused && !reduced() && doc.visibilityState !== 'hidden'; };
  function gcd(a, b) { while (b) { var t = b; b = a % b; a = t; } return a; }
  Roulette.prototype.sched = function () {
    var self = this;
    clearTimeout(this.t);
    if (!this.active()) return;
    // each roulette ticks at its own wall-clock phase (golden-ratio spread), so the "wave" never collapses into
    // lockstep after a tab switch, a pause or a scroll re-entry
    var phase = Math.round(((this.seed * 0.618034) % 1) * this.interval);
    var wait = this.interval - ((Date.now() + phase) % this.interval);
    if (wait < 120) wait += this.interval;
    this.t = setTimeout(function () { self.step(); }, wait);
  };
  Roulette.prototype.step = function () {
    var self = this;
    var pool = poolFor(this.el);
    if (pool.length < 2 || !this.active()) return;
    var cur = this.el.querySelector('.kj-roul__img.is-on');
    var nxt = cur === this.imgs[0] ? this.imgs[1] : this.imgs[0];
    // each roulette jumps by its own stride, coprime with the pool size so it still visits every silhouette
    var n = pool.length;
    var stride = 1 + (this.seed % Math.max(1, n - 1));
    while (n > 2 && gcd(stride, n) !== 1) stride = stride % (n - 1) + 1;
    this.i = (this.i + stride) % n;
    var src = pool[this.i];
    if (cur && cur.getAttribute('src') === src) { this.i = (this.i + 1) % pool.length; src = pool[this.i]; }
    nxt.classList.remove('is-out', 'is-on');
    nxt.classList.add('is-pre');
    var go = function () {
      nxt.onload = nxt.onerror = null;
      void nxt.offsetWidth;
      nxt.classList.remove('is-pre');
      nxt.classList.add('is-on');
      if (cur) { cur.classList.remove('is-on'); cur.classList.add('is-out'); }
      self.sched();
    };
    if (nxt.getAttribute('src') === src && nxt.complete) go();
    else { nxt.onload = go; nxt.onerror = function () { nxt.onload = nxt.onerror = null; self.sched(); }; nxt.setAttribute('src', src); }
  };
  Roulette.prototype.fast = function (on) {
    var ms = on ? 260 : this.base;
    if (this.interval === ms) return;
    this.interval = ms;
    this.el.classList.toggle('is-spin', !!on);
    this.sched();
  };
  function initRoulettes(ctx) { (ctx || doc).querySelectorAll('[data-kj-roul]').forEach(function (el) { new Roulette(el); }); }
  function rescheduleAll() { roulettes = roulettes.filter(function (r) { return r.el.isConnected; }); roulettes.forEach(function (r) { r.sched(); }); }
  doc.addEventListener('visibilitychange', rescheduleAll);
  L.setPaused = function (p) {
    L.paused = !!p;
    try { window.sessionStorage.setItem('kj-roul-paused', p ? '1' : '0'); } catch (e) {}
    doc.querySelectorAll('[data-kj-pause]').forEach(function (b) { b.setAttribute('aria-pressed', p ? 'true' : 'false'); });
    rescheduleAll();
  };
  try { L.paused = window.sessionStorage.getItem('kj-roul-paused') === '1'; } catch (e) {}

  /* ---------- <kj-advent> ---------- */
  var seenIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      seenIO.unobserve(en.target);
      en.target.classList.add('is-revealing');
      store('kj-seen:' + en.target.getAttribute('data-kj-cell'), '1');
    });
  }, { threshold: 0.35 }) : null;
  define('kj-advent', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.sid = this.getAttribute('data-section');
      this._onEnd = function (e) {
        if (design()) return;
        var cell = e.target.closest && e.target.closest('[data-kj-cell]');
        if (!cell || !self.contains(cell)) return;
        var st = cell.getAttribute('data-state');
        if (st === 'locked' || st === 'open') self.refresh(cell.getAttribute('data-kj-cell'));
      };
      this.addEventListener('kj:countdown:end', this._onEnd);
      // a cell already past its hour when this (maybe cached) HTML arrived → ask the server now
      if (!design()) {
        var nowS = Date.now() / 1000, due = null;
        this.querySelectorAll('[data-kj-cell][data-state="locked"], [data-kj-cell][data-state="open"]').forEach(function (c) {
          var to = parseFloat(c.getAttribute('data-to')) || 0;
          if (!due && to && to <= nowS) due = c.getAttribute('data-kj-cell');
        });
        if (due) this.refresh(due);
      }
      var pb = this.querySelector('[data-kj-pause]');
      if (pb) {
        pb.hidden = reduced() || !this.querySelector('[data-kj-roul]:not([data-fixed])');
        pb.setAttribute('aria-pressed', L.paused ? 'true' : 'false');
      }
      initRoulettes(this);
      // last 10 seconds: the roulette accelerates
      this.unsub = sub(function (now) {
        self.querySelectorAll('[data-kj-cell][data-state="locked"]').forEach(function (c) {
          var to = parseFloat(c.getAttribute('data-to')) || 0;
          var r = c.querySelector('[data-kj-roul]');
          if (r && r._kjRoul) r._kjRoul.fast(to - now < 10 && to - now > -2);
        });
      });
      // first time a freshly revealed piece is seen → short reveal
      if (!design() && !reduced() && seenIO) {
        this.querySelectorAll('[data-kj-cell][data-state="revealed"][data-new]').forEach(function (c) {
          if (!store('kj-seen:' + c.getAttribute('data-kj-cell'))) seenIO.observe(c);
        });
      }
      doc.dispatchEvent(new CustomEvent('kj:advent'));
    }
    disconnectedCallback() {
      this.removeEventListener('kj:countdown:end', this._onEnd);
      if (this.unsub) this.unsub();
    }
    next() {
      var best = null;
      this.querySelectorAll('[data-kj-cell][data-state="locked"]').forEach(function (c) {
        var to = parseFloat(c.getAttribute('data-to')) || 0;
        if (to && (!best || to < best.to)) best = { to: to, label: c.getAttribute('data-label') || '', kind: 'piece' };
      });
      if (!best) {
        var o = this.querySelector('[data-kj-cell][data-state="open"]');
        if (o) best = { to: parseFloat(o.getAttribute('data-to')) || 0, label: o.getAttribute('data-label') || '', kind: 'open' };
      }
      return best;
    }
    /* reveal at 0: ask the server again for this section (random 0–5 s + anti-cache). The server decides; if it still
       says "locked" (cache or a fast clock), retry with back-off; after 6 tries offer a reload link. */
    refresh(cellId) {
      var self = this;
      if (this._busy || !this.sid) return;
      var key = cellId || 'section';
      var n = L.tries[key] = (L.tries[key] || 0) + 1;
      if (n > 6) { this.giveUp(cellId); return; }
      this._busy = true;
      var delay = Math.random() * 5000 + (n > 1 ? Math.min(30000, 4000 * n) : 0);
      setTimeout(function () {
        var u = new URL(window.location.href);
        u.hash = '';
        u.searchParams.set('sections', self.sid);
        u.searchParams.set('_kj', String(Date.now()));
        fetch(u.toString(), { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (json) {
            var html = json && json[self.sid];
            var wrap = doc.getElementById('shopify-section-' + self.sid);
            if (!html || !wrap) throw new Error('empty');
            var tmp = doc.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.querySelector('#shopify-section-' + self.sid) || tmp.firstElementChild;
            if (!fresh) throw new Error('empty');
            wrap.replaceWith(fresh);
            if (window.KJ && window.KJ.init) window.KJ.init(fresh);
            initStamps(fresh);
          })
          .catch(function () { self._busy = false; setTimeout(function () { if (self.isConnected) self.refresh(cellId); }, 4000); });
      }, delay);
    }
    giveUp(cellId) {
      var cell = cellId && this.querySelector('[data-kj-cell="' + cellId + '"]');
      var slot = cell && cell.querySelector('[data-kj-retry]');
      if (slot) slot.hidden = false;
    }
  });

  /* ---------- <kj-next-tile> (hero): next piece of the calendar, else the opening ---------- */
  define('kj-next-tile', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      initRoulettes(this);
      var pb = this.querySelector('[data-kj-pause]');
      if (pb) {
        pb.hidden = reduced() || !this.querySelector('[data-kj-roul]:not([data-fixed]) .kj-roul__img');
        pb.setAttribute('aria-pressed', L.paused ? 'true' : 'false');
      }
      this._on = function () { self.sync(); };
      doc.addEventListener('kj:advent', this._on);
      this.sync();
    }
    disconnectedCallback() { doc.removeEventListener('kj:advent', this._on); }
    sync() {
      var adv = doc.querySelector('kj-advent');
      var n = adv && typeof adv.next === 'function' ? adv.next() : null;
      var lab = this.querySelector('[data-kj-next-label]');
      var cd = this.querySelector('kj-countdown');
      var to = n && n.to ? n.to : parseFloat(this.getAttribute('data-open-to')) || 0;
      var label = n && n.to ? n.label : this.getAttribute('data-open-label') || '';
      if (lab) lab.textContent = label;
      if (cd && typeof cd.set === 'function' && to) cd.set(to);
      this.classList.add('is-ready');
    }
  });

  /* ---------- subscription state ---------- */
  function campKey(c) { return 'kj-lp-in:' + (c || 'default'); }
  L.isIn = function (c) { return !design() && store(campKey(c)) === '1'; };
  L.markIn = function (c) { store(campKey(c), '1'); };
  function sha256(str) {
    if (!(window.crypto && window.crypto.subtle && window.TextEncoder)) return Promise.reject();
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    });
  }
  function utms() {
    var o = {};
    try { new URLSearchParams(window.location.search).forEach(function (v, k) { if (/^utm_|^fbclid$|^ttclid$/.test(k)) o[k] = v; }); } catch (e) {}
    return o;
  }
  /* Lead: Shopify custom event (a custom pixel in Settings → Customer events forwards it to Meta as "Lead") + dataLayer.
     The email only travels hashed (SHA-256). One event per signup (event_id for deduplication). */
  L.lead = function (email, origin, piece, camp) {
    var payload = { event_id: 'kj-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8), origin: origin || '', piece: piece || '', campaign: camp || '', page: window.location.pathname, utm: utms() };
    var send = function () {
      try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish('kojo:signup_completed', payload); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'kojo_signup' }, payload)); } catch (e) {}
    };
    sha256(String(email || '').trim().toLowerCase()).then(function (h) { payload.email_sha256 = h; }).catch(function () {}).then(send);
  };
  L.interest = function (piece, origin, camp) {
    var payload = { piece: piece || '', origin: origin || '', campaign: camp || '' };
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish('kojo:piece_interest', payload); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'kojo_piece_interest' }, payload)); } catch (e) {}
  };

  var TYPOS = { 'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gmail.es': 'gmail.com', 'gmail.con': 'gmail.com', 'gmal.com': 'gmail.com', 'gmaill.com': 'gmail.com', 'hotmial.com': 'hotmail.com', 'hotmal.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmail.co': 'hotmail.com', 'hotmail.con': 'hotmail.com', 'hotmial.es': 'hotmail.es', 'hotmal.es': 'hotmail.es', 'outlok.com': 'outlook.com', 'outllok.com': 'outlook.com', 'outlook.co': 'outlook.com', 'outlook.con': 'outlook.com', 'yaho.com': 'yahoo.com', 'yahoo.co': 'yahoo.com', 'yaho.es': 'yahoo.es', 'icloud.co': 'icloud.com', 'iclod.com': 'icloud.com', 'icloud.con': 'icloud.com' };

  /* ---------- <kj-signup> ---------- */
  define('kj-signup', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.form = this.querySelector('[data-kj-su-form]');
      if (!this.form) return;
      this.form.noValidate = true;
      this.input = this.form.querySelector('input[type="email"]');
      this.btn = this.form.querySelector('button[type="submit"]');
      this.msg = this.querySelector('[data-kj-su-msg]');
      this.fix = this.querySelector('[data-kj-su-fix]');
      this.fixBtn = this.querySelector('[data-kj-su-fixbtn]');
      this.ok = this.querySelector('[data-kj-su-ok]');
      this.note = this.querySelector('[data-kj-su-notify]');
      this.tagsEl = this.form.querySelector('[data-kj-su-tags]');
      this.baseTags = this.tagsEl ? this.tagsEl.value : '';
      this.sent = [];
      this.form.addEventListener('submit', function (e) { self.submit(e); });
      this.input.addEventListener('input', function () { self.clearMsg(); });
      this.input.addEventListener('blur', function () { self.suggest(); });
      if (this.fixBtn) this.fixBtn.addEventListener('click', function () { self.input.value = self.fixBtn.textContent; self.fix.hidden = true; self.input.focus(); });
      var again = this.querySelector('[data-kj-su-again]');
      if (again) again.addEventListener('click', function () { self.setState('form'); self.input.value = ''; try { self.input.focus(); } catch (e) {} });
      this._onSub = function (e) { if (e.detail && e.detail.from !== self) self.setState('ok'); };
      doc.addEventListener('kj:subscribed', this._onSub);
      var camp = this.getAttribute('data-camp');
      if (this.querySelector('[data-kj-posted]')) { L.markIn(camp); this.setState('ok'); }
      else if (L.isIn(camp)) this.setState('ok');
    }
    disconnectedCallback() { doc.removeEventListener('kj:subscribed', this._onSub); this._init = false; }
    setState(s) { this.setAttribute('data-state', s); if (this.ok) this.ok.hidden = s !== 'ok'; }
    clearMsg() { if (this.msg) { this.msg.hidden = true; this.msg.textContent = ''; } this.input.removeAttribute('aria-invalid'); }
    error(t) { if (this.msg) { this.msg.classList.remove('kj-su__msg--ok'); this.msg.textContent = t; this.msg.hidden = false; } }
    loading(on) { this.busy = on; if (this.btn) { this.btn.classList.toggle('is-loading', on); if (on) this.btn.setAttribute('aria-busy', 'true'); else this.btn.removeAttribute('aria-busy'); } }
    suggest() {
      if (!this.fix || !this.fixBtn) return;
      var v = (this.input.value || '').trim().toLowerCase();
      var at = v.lastIndexOf('@');
      var dom = at > 0 ? v.slice(at + 1) : '';
      var fixd = TYPOS[dom];
      if (fixd) { this.fixBtn.textContent = v.slice(0, at + 1) + fixd; this.fix.hidden = false; } else this.fix.hidden = true;
    }
    setPiece(label, piece, origin) {
      this.piece = piece || '';
      this.originOverride = origin || '';
      var tpl = this.getAttribute('data-notify');
      if (this.note && tpl && label) { this.note.textContent = tpl.replace('[pieza]', label); this.note.hidden = false; }
    }
    submit(e) {
      e.preventDefault();
      if (this.busy) return;
      var self = this;
      var email = (this.input.value || '').trim();
      if (!EMAIL_RE.test(email)) { this.error('Escribe un email válido, por ejemplo nombre@gmail.com.'); this.input.setAttribute('aria-invalid', 'true'); this.input.focus(); return; }
      var hp = this.querySelector('[data-kj-su-hp]');
      if (hp && hp.value) { this.done(email, true); return; }
      var now = Date.now();
      this.sent = this.sent.filter(function (t) { return now - t < 60000; });
      if (this.sent.length >= 3) { this.error('Has hecho varios intentos seguidos. Espera un minuto y vuelve a probar.'); return; }
      this.sent.push(now);
      var piece = this.piece || '';
      if (this.tagsEl) this.tagsEl.value = this.baseTags + (piece ? ',pieza-' + slug(piece) : '');
      this.input.value = email;
      this.loading(true);
      var fd = new FormData(this.form);
      var shop = fetch(this.form.getAttribute('action') || '/contact', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) {
          var u = r.url || '';
          if (/\/challenge/.test(u)) return 'challenge';
          if (/customer_posted=true/.test(u)) return 'ok';
          return 'error';
        })
        .catch(function () { return 'error'; });
      Promise.all([shop, this.klaviyo(email, piece)]).then(function (res) {
        if (res[0] === 'ok' || res[1] === 'ok') return self.done(email, false);
        // anti-spam check or anything unexpected: real submit, the server shows its own page/state
        self.loading(false);
        self.native();
      });
    }
    native() {
      try { HTMLFormElement.prototype.submit.call(this.form); } catch (e) { this.error('No hemos podido apuntarte. Inténtalo de nuevo en un momento.'); }
    }
    klaviyo(email, piece) {
      var key = this.getAttribute('data-kl-key'), list = this.getAttribute('data-kl-list');
      if (!key || !list) return Promise.resolve('skip');
      var props = Object.assign({ kj_origen: this.originOverride || this.getAttribute('data-origin') || '', kj_campana: this.getAttribute('data-camp') || '' }, utms());
      if (piece) props.kj_pieza = piece;
      var body = { data: { type: 'subscription', attributes: { custom_source: 'KOJO landing · ' + (this.getAttribute('data-camp') || ''), profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
      return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(key), { method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' }, body: JSON.stringify(body) })
        .then(function (r) { return r.ok ? 'ok' : 'error'; })
        .catch(function () { return 'error'; });
    }
    done(email, fake) {
      this.loading(false);
      var camp = this.getAttribute('data-camp');
      L.markIn(camp);
      if (!fake) L.lead(email, this.originOverride || this.getAttribute('data-origin'), this.piece || '', camp);
      this.setState('ok');
      try { this.ok.focus({ preventScroll: true }); } catch (e) {}
      doc.dispatchEvent(new CustomEvent('kj:subscribed', { detail: { from: this, camp: camp } }));
    }
  });

  /* ---------- go to the form / «Avísame» ---------- */
  function mainForm() {
    var f = doc.querySelector('#alta kj-signup');
    if (f) return f;
    var all = doc.querySelectorAll('kj-signup');
    return all.length ? all[all.length - 1] : null;
  }
  L.goToForm = function (form) {
    form = form || mainForm();
    if (!form) return;
    var box = form.closest('[id]') || form;
    try { box.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' }); } catch (e) { box.scrollIntoView(); }
    var input = form.querySelector('input[type="email"]');
    if (input && form.getAttribute('data-state') !== 'ok') setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, reduced() ? 0 : 450);
  };
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kj-notify]');
    if (!b) return;
    e.preventDefault();
    var label = b.getAttribute('data-piece-label') || '';
    var piece = b.getAttribute('data-piece') || label;
    var origin = b.getAttribute('data-origin') || 'aviso';
    var form = mainForm();
    var camp = form ? form.getAttribute('data-camp') : '';
    if (form && L.isIn(camp)) {
      L.interest(piece, origin, camp);
      b.classList.add('is-on');
      toast(label ? 'Hecho: te avisamos de ' + label + '.' : 'Ya estás en la lista.');
      return;
    }
    if (form && typeof form.setPiece === 'function') form.setPiece(label, piece, origin);
    L.interest(piece, origin, camp);
    L.goToForm(form);
  });
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kj-goto-form]');
    if (!b) return;
    e.preventDefault();
    L.goToForm();
  });

  /* ---------- <kj-sticky> bottom bar ---------- */
  function cookieBannerUp() {
    var host = doc.querySelector('pandectes-cmp');
    var el = host && host.shadowRoot ? host.shadowRoot.querySelector('dialog[open], .dialog.notice') : null;
    if (!el) el = doc.querySelector('#pandectes-banner, .pd-cookie-banner-window, .shopify-pc__banner__dialog, #shopify-pc__banner');
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.height > 0 && r.width > 0 && r.bottom > window.innerHeight - 260 && window.getComputedStyle(el).visibility !== 'hidden';
  }
  define('kj-sticky', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.lab = this.querySelector('[data-kj-stk-label]');
      this.cd = this.querySelector('kj-countdown');
      this.btn = this.querySelector('[data-kj-stk-btn]');
      this.vis = new Map();
      this.kb = false;
      this.openAt = parseFloat(this.getAttribute('data-open')) || 0;
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (ens) { ens.forEach(function (en) { self.vis.set(en.target, en.isIntersecting); }); self.update(); });
        doc.querySelectorAll('kj-signup').forEach(function (f) { self.io.observe(f); });
      }
      var raf = 0;
      this._onScroll = function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; self.update(); }); };
      this._onFocus = function (e) { var t = e.target; self.kb = e.type === 'focusin' && t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName); self.update(); };
      this._onSub = function () { self.sync(); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      doc.addEventListener('focusin', this._onFocus);
      doc.addEventListener('focusout', this._onFocus);
      doc.addEventListener('kj:subscribed', this._onSub);
      doc.addEventListener('kj:advent', this._onSub);
      this._onClick = function () { setTimeout(self._onScroll, 350); };
      doc.addEventListener('click', this._onClick);
      if (this.btn) this.btn.addEventListener('click', function (e) {
        if (self.classList.contains('is-live')) return;
        e.preventDefault();
        L.goToForm();
      });
      this.unsub = sub(function (now) { if (self.openAt && now >= self.openAt && !self.classList.contains('is-live')) self.sync(); });
      this.sync();
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      doc.removeEventListener('focusin', this._onFocus);
      doc.removeEventListener('focusout', this._onFocus);
      doc.removeEventListener('kj:subscribed', this._onSub);
      doc.removeEventListener('kj:advent', this._onSub);
      doc.removeEventListener('click', this._onClick);
      if (this.io) this.io.disconnect();
      if (this.unsub) this.unsub();
    }
    sync() {
      var now = Date.now() / 1000;
      var live = this.openAt && now >= this.openAt;
      this.classList.toggle('is-live', !!live);
      var form = mainForm();
      var isIn = form ? L.isIn(form.getAttribute('data-camp')) : false;
      this.classList.toggle('is-in', !!isIn && !live);
      if (live) {
        if (this.lab) this.lab.textContent = this.getAttribute('data-live-label') || '';
        if (this.cd) this.cd.hidden = true;
        if (this.btn) { this.btn.textContent = this.getAttribute('data-live-cta') || ''; this.btn.setAttribute('href', this.getAttribute('data-live-url') || '/collections/all'); }
        return;
      }
      var adv = doc.querySelector('kj-advent');
      var n = adv && typeof adv.next === 'function' ? adv.next() : null;
      var to = n && n.to ? n.to : this.openAt;
      var label = n && n.to ? n.label : this.getAttribute('data-open-label') || '';
      if (this.lab) this.lab.textContent = label;
      if (this.cd && to && typeof this.cd.set === 'function') { this.cd.hidden = false; this.cd.set(to); }
    }
    update() {
      var anyForm = false;
      this.vis.forEach(function (v) { if (v) anyForm = true; });
      var y = window.pageYOffset || doc.documentElement.scrollTop || 0;
      var show = y > 360 && !anyForm && !this.kb && !cookieBannerUp() && !doc.documentElement.classList.contains('kj-locked');
      this.classList.toggle('is-shown', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) this.removeAttribute('inert'); else this.setAttribute('inert', '');
    }
  });

  /* ---------- Reyes seal stamp ---------- */
  var stampIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      stampIO.unobserve(en.target);
      en.target.classList.add('is-stamp');
      setTimeout(function () { en.target.classList.add('is-stamped'); en.target.classList.remove('is-stamp'); }, 520);
    });
  }, { threshold: 0.6 }) : null;
  function initStamps(ctx) {
    (ctx || doc).querySelectorAll('[data-kj-stamp]').forEach(function (el) {
      if (el._kjStamp) return;
      el._kjStamp = true;
      if (!stampIO || reduced() || design()) { el.classList.add('is-stamped'); return; }
      stampIO.observe(el);
    });
  }

  /* ---------- ribbon pause (tap) + bento «ver todas» ---------- */
  doc.addEventListener('click', function (e) {
    var rib = e.target.closest && e.target.closest('[data-kj-ribbon]');
    if (rib && !e.target.closest('a')) {
      rib.classList.toggle('is-paused');
      rib.setAttribute('aria-pressed', rib.classList.contains('is-paused') ? 'true' : 'false');
    }
    var more = e.target.closest && e.target.closest('[data-kj-more-btn]');
    if (more) {
      var grid = doc.getElementById(more.getAttribute('aria-controls'));
      if (!grid) return;
      grid.removeAttribute('data-collapsed');
      more.setAttribute('aria-expanded', 'true');
      more.hidden = true;
      var first = grid.querySelector('[data-more] a, [data-more] button');
      if (first) try { first.focus({ preventScroll: true }); } catch (err) {}
    }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var rib = e.target.closest && e.target.closest('[data-kj-ribbon]');
    if (rib && e.target === rib) { e.preventDefault(); rib.click(); }
  });
  function initBento(ctx) {
    (ctx || doc).querySelectorAll('[data-kj-bento-grid]').forEach(function (g) {
      if (g._kj) return;
      g._kj = true;
      if (g.querySelector('[data-more]') && !design()) g.setAttribute('data-collapsed', '');
      else { var b = doc.querySelector('[aria-controls="' + g.id + '"]'); if (b) b.hidden = true; }
    });
  }

  /* ---------- hero background video: fade in once it really plays (the photo underneath is the poster/LCP),
     pause / play button (WCAG 2.2.2). Loading and on-screen autoplay come from kojo-core.js (video[data-kj-autoplay]). */
  doc.addEventListener('playing', function (e) {
    var v = e.target;
    if (v && v.hasAttribute && v.hasAttribute('data-kj-fade')) v.classList.add('is-playing');
  }, true);
  function markPlaying(ctx) {
    // a video that started before this script arrived missed its 'playing' event: show it anyway
    (ctx || doc).querySelectorAll('video[data-kj-fade]').forEach(function (v) { if (!v.paused && v.readyState > 2) v.classList.add('is-playing'); });
  }
  function bgVideos(root) { return root ? Array.prototype.slice.call(root.querySelectorAll('.kj-hero2__vid')) : []; }
  function shownVideo(root) { return bgVideos(root).filter(function (v) { return v.offsetParent !== null; })[0] || null; }
  // the button shows what the visible video is really doing (autoplay can be refused, e.g. iPhone low-power mode)
  function syncToggle(root) {
    var b = root && root.querySelector('[data-kj-bgvid-toggle]');
    if (!b) return;
    var v = shownVideo(root);
    var paused = !v || v.paused;
    b.setAttribute('data-paused', paused ? 'true' : 'false');
    b.setAttribute('aria-label', (paused ? b.getAttribute('data-label-play') : b.getAttribute('data-label-pause')) || '');
  }
  ['play', 'pause'].forEach(function (ev) {
    doc.addEventListener(ev, function (e) {
      var v = e.target;
      if (v && v.classList && v.classList.contains('kj-hero2__vid')) syncToggle(v.closest('.kj-hero2'));
    }, true);
  });
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kj-bgvid-toggle]');
    if (!b) return;
    var root = b.closest('.kj-hero2');
    var v = shownVideo(root);
    var pause = !!(v && !v.paused);
    bgVideos(root).forEach(function (x) {
      x._kjUserPaused = pause;
      if (!x._kjGuard) {
        x._kjGuard = true;
        // the core autoplay observer calls play() when the video re-enters the viewport: respect the visitor's choice
        x.addEventListener('play', function () { if (x._kjUserPaused) x.pause(); });
      }
      if (pause) { x.pause(); return; }
      if (x.offsetParent === null) return; // the other breakpoint's video stays untouched
      if (x.getAttribute('data-src') && !x.getAttribute('src')) x.setAttribute('src', x.getAttribute('data-src'));
      var p = x.play && x.play();
      if (p && p.catch) p.catch(function () {});
    });
    setTimeout(function () { syncToggle(root); }, 80);
  });
  function initVideoToggles(ctx) {
    (ctx || doc).querySelectorAll('[data-kj-bgvid-toggle]').forEach(function (b) {
      var root = b.closest('.kj-hero2');
      setTimeout(function () { syncToggle(root); }, 3000); // autoplay refused → offer «play»
    });
  }
  // roulette pause buttons (calendar + hero "?"): one switch for every roulette on the page
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kj-pause]');
    if (!b) return;
    e.preventDefault();
    L.setPaused(!L.paused);
  });
  /* «Fondo por detrás de la cabecera»: only when the hero is really the first thing in <main>, or comes right after
     the campaign bar laid over the header ticker. The section's own script does it at parse time; this repeats it
     for the theme editor (re-rendered / moved sections) and as a safety net. Never removes the home hero's class. */
  function syncOverlap() {
    var heroes = doc.querySelectorAll('.kj-hero2');
    if (!heroes.length) return;
    var ticker = !!doc.querySelector('.kj-hdr__ticker');
    var on = false;
    heroes.forEach(function (h) {
      var w = h.closest('.shopify-section') || h.parentNode;
      var p = w && w.previousElementSibling;
      var ok = h.classList.contains('kj-hero2--overlap') && (!p || (!p.previousElementSibling && p.classList.contains('kj-shopify-section--pbar') &&
        (!p.querySelector('.kj-pbar') || (!!p.querySelector('.kj-pbar--over') && ticker))));
      h.classList.toggle('kj-hero2--on', ok);
      if (ok) on = true;
    });
    if (on) doc.body.classList.add('kj-has-overlap');
    else if (!doc.querySelector('.kj-hero--overlap')) doc.body.classList.remove('kj-has-overlap');
  }
  doc.addEventListener('shopify:section:unload', function () { setTimeout(syncOverlap, 0); });
  doc.addEventListener('shopify:section:reorder', function () { setTimeout(syncOverlap, 0); });

  function boot(ctx) { initStamps(ctx); initBento(ctx); markPlaying(ctx); initVideoToggles(ctx); syncOverlap(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { boot(doc); });
  else boot(doc);
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); initRoulettes(e.target); });
})();
